import React, { useState, useEffect } from "react";
import { getemployeeDetailsApi } from "../../../../Redux/Services";
import Card from "../../../../component/Card/Card";
import "./ReportingManagerDetails.scss";
import { showErrorToastMessage, showSuccessToastMessage } from "../../../../component/Toasts/Toasts";

const ReportingManagerDetailsCard = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [reportingManager, setReportingManager] = useState<any>(null);
    
    const loginUser = localStorage.getItem('login');
    const employeeObjectID = loginUser ? JSON.parse(loginUser).id : null;

    useEffect(() => {
        const fetchDetails = async () => {
            if (!employeeObjectID) {
                setIsLoading(false);
                return;
            }

            try {
                const response = await getemployeeDetailsApi(employeeObjectID);
        
                if (response && response.success && response.data && response.data.length > 0) {
                    const employeeData = response.data[0];
                    setReportingManager(employeeData);
                    showSuccessToastMessage("Reporting Manager details fetched successfully.");
                } else {
                    console.error("Failed to fetch employee details or data is empty.");
                    showErrorToastMessage("Failed to fetch reporting manager details.");
                }
            } catch (error) {
                console.error("An error occurred while fetching employee details:", error);
                showErrorToastMessage( "An error occurred while fetching reporting manager details.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchDetails();
    }, [employeeObjectID]);

    if (isLoading) {
        return (
            <Card>
                <div className="reporting-manager-card loading-state">
                    {/* <Spinner animation="border" variant="primary" className="loading-spinner" /> */}
                    <p className="mt-2">Loading Details of Nominator...</p>
                </div>
            </Card>
        );
    }

    return (
        <Card>
            <div className="reporting-manager-card">
                <h5 className="title">Nominator Details</h5>

                <div className="row g-3">
                    <div className="col-md-6">
                        <div className="detail-item">
                            <p className="detail-item-label">Employee ID</p>
                            <p className="detail-item-value">{reportingManager?.employeeId ?? "N/A"}</p>
                        </div>
                    </div>
                    
                    <div className="col-md-6">
                        <div className="detail-item">
                            <p className="detail-item-label">Name</p>
                            <p className="detail-item-value">
                                {[reportingManager?.candidateName, reportingManager?.middleName, reportingManager?.lastname]
                                    .filter(Boolean)
                                    .join(' ') || 'N/A'}
                            </p>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="detail-item">
                            <p className="detail-item-label">Department</p>
                            <p className="detail-item-value">{reportingManager?.department ?? "N/A"}{reportingManager?.subDepartment ? ` - ${reportingManager?.subDepartment}` : ""}</p>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="detail-item">
                            <p className="detail-item-label">Designation</p>
                            <p className="detail-item-value">{reportingManager?.designation ?? "N/A"}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ReportingManagerDetailsCard;